/**
 * @module geo/payload/facade/services
 */
import { MapOptions } from '../../../types/map';
import { SERVICE_PAYLOAD } from './SERVICE_PAYLOAD';
import { KindService } from '../../../types/services/kind.service';

/**
 * A service to export and retrieve an image of the map application.
 * @since v 2.1
 * @see [[GeoMap.serviceExportAsImage]]
 */
export class SERVICE_GET_IMAGE_MAP extends SERVICE_PAYLOAD {


  parameters: Partial<ServiceGetImageMapParameters>;


  public kindService: KindService = KindService.GET_IMAGE_MAP;

  /**
   * @param options object with properties values
   */
  constructor(options: { parameters: ServiceGetImageMapParameters | undefined, transient: boolean, id: string }) {

    super(options);
    this.parameters = new ServiceGetImageMapParameters();
    if (options.parameters) {
      Object.assign(this.parameters, options.parameters);
    }

  }
}
/**
 * options for serviceGetImageMap
 */
export class ServiceGetImageMapParameters {
  map?: MapOptions | null;
  /**
   * Mime type to use for map print (image/png, image/jpeg ...)
   */
  printFormat?: string;
  /**
   * Width in pixel of final image. default is 800
   */
  pxWidth?: number;
  /**
   * Height in pixel of final image. default is 600
   */
  pxHeight?: number;
  /**
   * Has to print scale line ?
   */
  scaleLine?: boolean;
  /**
   *
   */
  scaleText?: number;
  /**
   * Has to print north arrow ?
   */
  northArrow?: boolean;
  /**
   * Has to preserve Scale ?
   */
  preserveScale?: boolean;
  /**
   * Scale denominator of map print result
   */
  scaleDenominator?: number;
  /**
   * Has to print legend (if true return a zip file with map and legend) ?
   */
  withLegend?: boolean;
  /**
   * Has to print label "other values" ?
   */
  otherValuesLabel?: string;
  /**
   * print DPI, default to 90
   */
  dpi?: number;
  /**
   *
   */
  vectorMap?: boolean;

}